// border-tertiary bg-successBg
export const TertiaryBox: React.CSSProperties = {
  border: '2px solid #83BB26',
  backgroundColor: '#E6F1D4',
  borderRadius: '1rem',
  padding: '1rem 1rem 1rem 1rem',
  marginBottom: '1rem',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
};

// border-quatenary bg-quatenaryBg
export const QuatenaryBox: React.CSSProperties = {
  border: '2px solid #1DBADF',
  backgroundColor: '#D2F1F9',
  borderRadius: '1rem',
  padding: '1rem 1rem 1rem 1rem',
  marginBottom: '1rem',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
};

// border-secondary bg-errorBg
export const SecondaryBox: React.CSSProperties = {
  border: '2px solid #FF2180',
  backgroundColor: '#FFEEF6',
  borderRadius: '1rem',
  padding: '1rem 1rem 1rem 1rem',
  marginBottom: '1rem',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
};
